import React from 'react'
import { DepositHeader } from '../index'
import SubmitBtn from '../Components/SubmitBtn'
import QRCodeView from '../Components/QRCodeView'
import { GetParamsData } from '$Deposits/lib/LibCommonData'
import CHANNEL_NextStepCom from '$Deposits/Components/CTC/CHANNEL_NextStep'
import copy from 'copy-to-clipboard';

class CHANNEL_NextStep extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showTrips: true,
        };
        this.qrCodeRef = React.createRef();
        this.copyStatusRef = React.createRef();
    }

    copys = (txt, copyStatus) => {
        try {
            const value = String(txt)
            copy(value)
            if (this.copyStatusRef.current) {
                if (copyStatus === 'deepLink') {
                    this.copyStatusRef.current.style.display = 'inline';
                } else {
                    this.copyStatusRef.current.style.display = 'none';
                }
            }
            const { toastTip } = GetParamsData()
            toastTip.success('Sao Chép Thành Công')
        } catch (error) {
            // Handle error
        }
    }

    renderContent = (propCon) => {
        const {
            MethodsActive,
            DepositPayments,
            DepositBankActive,
            backClick,
            onChange,
        } = propCon

        const { deepLink, exchangeRate } = DepositPayments || {}
        const { code } = DepositBankActive || {}

        return (
            <div className='nextModal'>
                <div className='nextModalCenter'>
                    <div className='viewArea'>
                        <div className='CTCTitleIcon'>
                            <div className={code + 'Icon'} />
                            <span>{`Tether USD (${code})`}</span>
                        </div>
                        <div className='borders' />

                        <div className='exchangeRate'>
                            <p className='exchangeTitle'>Tỷ Gía Hối Đoái</p>
                            <p className='exchangeValue'>1 {code} = {exchangeRate} đ</p>
                        </div>
                        
                        <div className='redtip'>
                            Vui lòng lưu ý giao dịch sẽ được tính theo tỷ giá hối đoái thực tại thời điểm thực hiện giao dịch.
                        </div>
                        <div className='line-distance'></div>
                        <div className='borders' />

                        <div className='CTCqrcode' ref={this.qrCodeRef}>
                            <span>Mã QR</span>
                            <QRCodeView deepLink={deepLink} key={1} />
                        </div>

                        <div className='borders' />

                        <p className='inputTitle'>Địa Chỉ Ví</p>
                        <div className='paymentData CTC_copy'>
                            <div className='paymentItem CTC_copyItem' onClick={() => this.copys(deepLink, 'deepLink')}>
                                <span className='paymentValue'>{deepLink}</span>
                                <span className='copyIcon' />
                                <span className='copyActive' ref={this.copyStatusRef} style={{display: 'none'}} />
                            </div>
                        </div>
                        <div className='blueTip before-ctc'>
                            <p>Số tiền gửi tối thiểu : 1 {code}</p>
                            <p>Địa chỉ ví này là dành riêng cho bạn và có thể sử dụng được nhiều lần.</p>
                        </div>
                    </div>
                    <SubmitBtn
                        submitBtn={() => { return true }}
                        onPress={onChange}
                        submitBtnItem={'Đóng'}
                    />
                </div>
            </div>
        )
    }

    render() {
        return (
            <CHANNEL_NextStepCom
                CHANNEL_NextStep={this.renderContent}
            />
        );
    }
}

export default CHANNEL_NextStep